import React from "react";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow,
  Typography,
  styled,
  IconButton
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import { useNavigate, usePathParam } from "hooks";
import { AsyncContent } from "components";
import { useGetConnectionDeals, useGetConnections } from "../../queries/query-selectors/plaid-query-selectors";
import { useSyncInvestmentHoldings } from "../../queries/query-mutations/plaid-query-mutations";

const TableCell = styled(MuiTableCell)({
  fontSize: "16px"
});

export const PlaidConnection: React.FC = () => {
  const plaidConnectionId = usePathParam("plaid");
  const { data: deals, isLoading } = useGetConnectionDeals(plaidConnectionId!);
  const { data: connections, isLoading: connectionsLoading } = useGetConnections();
  const { mutate: doSyncItem, isLoading: synching } = useSyncInvestmentHoldings();
  const navigate = useNavigate();

  const connection = connections?.find((conn) => conn.id === plaidConnectionId);

  if (!connection && !connectionsLoading) {
    return <div>Oops! connection was not found</div>;
  }

  return (
    <Stack flexGrow={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography sx={{ padding: "16px" }} variant="body1">
          Deals of {connection?.investor.name} in {connection?.institution_name}
        </Typography>
        <IconButton
          disabled={!connection}
          sx={{
            color: "#0a3142",
            background: "white",
            border: "0.5px solid #bac7ce"
          }}
          onClick={() => doSyncItem(connection!.item_id)}
          size="sm"
        >
          <RefreshIcon fontSize="md" />
        </IconButton>
      </Stack>
      <Box flexGrow={1} sx={{ bgcolor: "white", borderRadius: "8px" }}>
        <AsyncContent loading={isLoading || connectionsLoading || synching}>
          {!deals?.length && (
            <Typography variant="h6" sx={{ textAlign: "center", paddingTop: "40px" }}>
              There are currently no deals found for this connection. You may try to reconnect to plaid to get updates
            </Typography>
          )}
          {!!deals?.length && (
            <Table>
              <TableHead>
                <TableRow sx={{ fontWight: 700 }}>
                  <TableCell>Deals</TableCell>
                  <TableCell>Ticker</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deals.map((deal) => (
                  <TableRow sx={{ borderBottom: "1px solid #dae0e2" }} key={deal.deal_id}>
                    <TableCell
                      sx={{ color: "#26A6AE", cursor: "pointer" }}
                      onClick={() => navigate({ route: "dealReport", params: { deal_id: deal.deal_id } })}
                    >
                      {deal.deal.title}
                    </TableCell>
                    <TableCell>{deal.ticker_symbol}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </AsyncContent>
      </Box>
    </Stack>
  );
};
